module.exports = function(s) {
  s = (s === undefined) ? "" : s;
  s = (s === null) ? "" : s;
  s = s.toString();
  return s;
};



//////////////////
// WEBPACK FOOTER
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/node_modules/list.js/src/utils/to-string.js
// module id = 442
// module chunks = 1 5 15 16 25 26 27 28 29 30 31 32 33